import { useUser } from '../../../hooks/use-user';
import { Link } from 'react-router-dom';
import { Button } from '../../../ui/components/ui/button';
import { UserType } from '../../../lib/interfaces/user';
import CustomerInvitedFetch from '../customer/invitation-fetcher';
import InternalInvitedFetch from '../internal/invitation-fetcher';
import AddCustomerUserForm from '../customer/add-user';
import AddInternalUserFormParent from '../internal/add-user';
import { useState } from 'react';

const CollaboratorsInvitationsPage = () => {
  const { user } = useUser();
  const [, setReload] = useState(false);

  return (
    <div className="flex flex-col gap-5 h-full">
      <div className="flex justify-end">
        <div className="flex gap-3">
          <Button asChild variant="outline">
            <Link to="/collaborators">Benutzer anzeigen</Link>
          </Button>
          <>
            {user?.userType === UserType.Customer ? (
              <AddCustomerUserForm setReload={setReload} />
            ) : (
              <AddInternalUserFormParent setReload={setReload} />
            )}
          </>
        </div>
      </div>
      <>{user?.userType === UserType.Customer ? <CustomerInvitedFetch /> : <InternalInvitedFetch />}</>
    </div>
  );
};

export default CollaboratorsInvitationsPage;
